import React from 'react'
import Link from 'gatsby-link'
import { Route, Redirect } from "react-router-dom";
import SurveyPage from './survey';
import ThankYouPage from './thankyou';
import NotFoundPage from './404';
import NoKeyPage from './nokey';

const IndexPage = (props) => {
  return(
      <div>
        <Route
         render={({ location }) => (
           <div>
             <Route
               location={location}
               key={location.key+'no'}
               exact
               path="/"
               render={() => <Redirect to="/nokey" />}
             />
             <Route
               location={location}
               key={location.key+'ty'}
               exact
               path="/thankyou"
               render={ThankYouPage}
             />
             <Route
               location={location}
               key={location.key+'nk'}
               exact
               path="/nokey"
               render={NoKeyPage}
             />
             <Route
               location={location}
               key={location.key+'sn'}
               path="/"
               render={({location})=>(
                 <Route
                   location={location}
                   key={location.key+'4'}
                   path="/survey/:respondent_id"
                   component={SurveyPage}
                 />
                )}
             />
           </div>
         )}
         />
       </div>
)}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js